/*
 * @Descripttion: 药品超出挂网价提醒弹窗（诊间结算/诊断完毕/零售预结算共用）
 * @version: 1.0
 * @Author:
 * @email:
 * @Date: 2026-09-10 17:33:49
 * @LastEditors:
 * @LastEditTime: 2026-09-10 17:33:49
 */
import { Button, Modal, Space } from 'antd'
import React, { ReactElement } from 'react'

// 金额展示：整数保留两位小数（45 → 45.00），小数去掉末尾多余的 0（4.25300 → 4.253），取不到值时展示 '-'
export const formatAmount = (v: any, digits: number) => {
  const num = Number(v)
  if (v === undefined || v === null || v === '' || isNaN(num)) {
    return '-'
  }
  if (num % 1 === 0) {
    return num.toFixed(2)
  }
  const text = num.toFixed(digits)
  return text.indexOf('.') >= 0 ? text.replace(/\.?0+$/, '') : text
}

/**
 * 挂网价异常明细：
 * overOnlineLimitFlag = 1 超出挂网价
 * overOnlineLimitFlag = 2 非挂网药品
 */
export const isOverOnlineLimit = (m: any): boolean =>
  m?.overOnlineLimitFlag == 1 || m?.overOnlineLimitFlag == 2

export const getOverOnlineLimitList = (items?: any[]): any[] =>
  items?.filter((m: any) => isOverOnlineLimit(m)) || []

// 单条提醒文案
const getOverOnlineLimitText = (m: any) =>
  m?.overOnlineLimitFlag == 2
    ? `【${m?.name}】非挂网药品`
    : `【${m?.name}】单价${formatAmount(
        m?.retailPrice,
        5
      )}，超挂网价${formatAmount(m?.onlineLimitPrice, 2)}`

/**
 * 药品超出挂网价提醒
 * 仍要继续 → onContinue（继续原按钮的逻辑）
 * 立即修改 → onCancel（仅关闭弹窗）
 */
export const OverOnlineLimitModal = (props: {
  visible: boolean
  list?: any[]
  onContinue: () => void
  onCancel: () => void
}): ReactElement => {
  return (
    <Modal
      title='温馨提醒'
      width={520}
      visible={props.visible}
      maskClosable={false}
      footer={null}
      onCancel={props.onCancel}
    >
      <div style={{ maxHeight: '320px', overflowY: 'auto' }}>
        {props.list?.map((m: any, index: number) => (
          <div key={index} style={{ marginBottom: '6px' }}>
            {`${index + 1}. ${getOverOnlineLimitText(m)}`}
          </div>
        ))}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '24px',
        }}
      >
        <Space>
          <Button onClick={props.onContinue}>仍要继续</Button>
          <Button type='primary' onClick={props.onCancel}>
            立即修改
          </Button>
        </Space>
      </div>
    </Modal>
  )
}
